import { useContext } from 'react';
import { PremiumContext, type PremiumContextType } from '../contexts/premiumContextDef';

export function usePremium(): PremiumContextType {
  const context = useContext(PremiumContext);
  if (context === undefined) {
    throw new Error('usePremium must be used within a PremiumProvider');
  }
  return context;
}
